import {createContext, useContext} from 'react'
import {useSelector} from 'react-redux'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {getAlternativeOffersQueryParams} from 'modules/alternativeOffers/selectors'

import {useLazyGetOfferCheckQuery} from '@daedalus/core/src/offer/services/offerCheckApi'
import {OfferCheckApiRequestParams} from '@daedalus/core/src/offer/types/OfferCheck'
import {useLazyGetOffersQuery} from '@daedalus/core/src/sapi/services/searchApi'

type triggerOfferCheckParams = {
  apiParams: OfferCheckApiRequestParams
  offerId: string
  onSuccess?: ({httpRequestId}: {httpRequestId: string}) => void
}

type OfferCheckContextType = {
  triggerOfferCheck: (params: triggerOfferCheckParams) => void
}

const OfferCheckContext = createContext<OfferCheckContextType>({
  triggerOfferCheck: undefined
})

export const useOfferCheckContext = () => useContext(OfferCheckContext)

export const OfferCheckContextProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const offersQueryParams = useSelector(state => {
    const hotelId = getAccommodationPageHotelId(state)
    return getAlternativeOffersQueryParams(state, hotelId)
  })

  const [fetchAllOffers] = useLazyGetOffersQuery()
  const [fetchOfferCheck] = useLazyGetOfferCheckQuery()

  const triggerOfferCheck: OfferCheckContextType['triggerOfferCheck'] = ({
    apiParams,
    offerId,
    onSuccess
  }) => {
    fetchOfferCheck({
      ...apiParams,
      options: {onSuccess, offerId}
    })
    fetchAllOffers(offersQueryParams, true)
  }

  return (
    <OfferCheckContext.Provider value={{triggerOfferCheck}}>
      {children}
    </OfferCheckContext.Provider>
  )
}
